import * as React from 'react';

export const RadioGroupContext = React.createContext(false);
